export default "__VITE_ASSET__ae6be04f__"